// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// HOST GEO SCHEMA
/////////////////////////////////////////

export const HostGeoSchema = z.object({
  country: z.string().nullable(),
  countryCode: z.string().nullable(),
  region: z.string().nullable(),
  city: z.string().nullable(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  asn: z.string().nullable(),
  asnOrg: z.string().nullable(),
})

export type HostGeo = z.infer<typeof HostGeoSchema>

export default HostGeoSchema;
